import { getMessaging, isSupported, Messaging, onMessage } from 'firebase/messaging'
import { app } from './firebase-init'

export const publicVapidKey = process.env.NEXT_PUBLIC_PUBLIC_VAPID_KEY || ''

export const messagingSupportedPromise: Promise<boolean> =
  typeof window !== 'undefined' && typeof navigator !== 'undefined'
    ? isSupported().catch(() => false)
    : Promise.resolve(false)

export let messaging: Messaging | undefined = undefined

// Only initialize messaging in browser environment
if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  /* Setting up firebase messaging */
  messagingSupportedPromise
    .then(supported => {
      if (supported) {
        messaging = getMessaging(app)
        onMessage(messaging, async payload => {
          console.log('Message received. ', payload)

          await navigator.serviceWorker
            .getRegistration('/firebase-cloud-messaging-push-scope')
            .then(registration => {
              const title = payload?.data?.title || '2meters'
              const body = payload?.data?.body || 'You have a new message'

              const options = {
                title: title,
                body: body,
                icon: '/default-notification-logo.png',
              }

              return registration?.showNotification(title, options)
            })
        })
      }
    })
    .catch(e => console.log(`Init Messaging Error`, e))
}
